<template>
  <div>
    <div class="title-box">
      <span class="title">{{ moduleData.affiliationType }}</span>
      <RxkButton text @click="handleAdd">新增{{ moduleData.affiliationType }}</RxkButton>
    </div>
    <div class="custom-subList">
      <el-table
        class="custom-table"
        :data="tableData"
        :border="true"
        style="width: 100%"
        header-cell-class-name="custom-header"
      >
        <template v-for="(item, index) in moduleData.subs" :key="index">
          <el-table-column min-width="200px" :width="item.labelWidth" :label="item.title">
            <template #header>
              <span class="required-icon">{{ item.checkedInput === 1 ? '*' : '' }}</span>
              <span>{{ item.title }}</span>
            </template>
            <template #default="{ row, $index }">
              <div class="val">
                <Render
                  :data="{ ...item }"
                  :index="index + '-' + $index"
                  :value="row[item.field]"
                  :disabled="item.disabled"
                  ref="renderRef"
                  :isTxt="item.isTxt || delayEdit"
                  :comp-name="item.customField.renderConfig.compName"
                  :renderConfig="item.customField.renderConfig"
                  @changeValue="value => (row[item.field] = value)"
                />
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" fixed="right" width="80px">
          <template #default="{ $index }">
            <div>
              <RxkButton text v-if="tableData.length > 1" @click="handleDelete($index)">
                删除
              </RxkButton>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script setup lang="ts">
import Render from '@/components/custom/form/components/render.vue'
import { onMounted, ref, unref } from 'vue'
import { titlelist } from '@/views/erp/enums'
import { cloneDeep } from '@/utils/tools'
import { isNullOrUndefOrEmpty } from '@/utils/is'

const props = defineProps({
  moduleData: {
    type: Object,
    default: () => {}
  },
  applyIds: {
    type: Object,
    default: () => {}
  },
  comType: {
    type: Number,
    default: 101 // 101 erp   102 bpm
  }
})
const delayEdit = ref(true)
onMounted(() => {
  tableData.value = cloneDeep(props.moduleData.tableData) || []
  setTimeout(() => {
    delayEdit.value = false
  }, 300)
})

const tableData = ref<Recordable[]>([])
function handleAdd() {
  let newRow: Recordable = {}
  props.moduleData.subs.forEach((item: Recordable) => {
    newRow[item.field] = unref(item.defaultValue)
  })
  tableData.value.push(newRow)
}

function handleDelete(index: any) {
  if (tableData.value.length <= 1) {
    ElMessage.error('至少有一行')
    return
  }
  tableData.value.splice(index, 1)
}

function getData() {
  console.log(tableData.value, 'xxxxxxx', props.moduleData.subs)

  titlelist.forEach(data => {
    if (props.moduleData.affiliationType === data.label) {
      tableData.value.forEach(v => {
        v.subType = data.value
      })
    }
  })
  return tableData.value || []
}

function validate() {
  let valid = ''
  props.moduleData.subs.forEach((field: Recordable) => {
    if (field.checkedInput === 1 && !field.isTxt && !field.disabled) {
      console.log(tableData.value)
      tableData.value.forEach((item: Recordable) => {
        if (isNullOrUndefOrEmpty(item[field.field])) {
          valid = `${field.affiliationType}-${field.title}必填`
        }
      })
    }
  })
  return valid
}

// TODO 子表编辑暂时不做
function getChangeList() {
  return []
}

defineExpose({
  getData,
  getChangeList,
  validate
})
</script>
<style lang="scss" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;
  margin-top: 16px;
  .title {
    font-size: 14px;
    color: #333333;
    font-weight: 700;
    display: inline-block;
    border-left: 3px solid #5687ff;
    padding-left: 9px;
  }
}
.custom-subList {
  width: 100%;
  height: 100%;
  &.reHeight {
    height: calc(100% - 65px);
  }

  :deep(.el-table__body) {
    .el-table__cell {
      padding: 0;
      height: 40px;
      line-height: 40px;
      border-right-color: transparent;
      .cell {
        line-height: 40px;
        font-size: 14px;
        color: #333333;
      }
    }
  }
  :deep(.custom-header) {
    padding: 0;
    height: 40px;
    line-height: 40px;
    background: #f4f4f5 !important;
    .cell {
      line-height: 40px;
      font-size: 14px;
      color: #666666;
      font-weight: 700;
    }
  }
}
.addRow {
  line-height: 48px;
  color: #5687ff;
  display: inline-block;
}
.required-icon {
  color: #f56c6c;
}
</style>
